function onSearchSubmitCustom(e) {
  var t = $(e).closest("#SearchContainer"),
    i = $(e).val(),
    s = t.find("#search-results");
  if ($(e).val().length > 0) {
    s.addClass("vjs-seeking"),
      s.html('<div class="vjs-loading-spinner"></div>');
    "en" != Shopify.locale &&
      `${Shopify.locale}/search?view=ajax&q=${i}&options%5Bprefix%5D=last&type=product,page,collection`,
      fetch(
        `${Shopify.URL.search_url}?view=ajax&q=${i}&options%5Bprefix%5D=last&type=product,page,collection`
      )
        .then((e) => {
          if (!e.ok) {
            var t = new Error(e.status);
            throw (this.close(), t);
          }
          return e.text();
        })
        .then((e) => {
          var t = document.createElement("div");
          t.innerHTML = e;
          var o = t.querySelector("#collectionResult"),
            r = t
              .querySelector("#itemResultsCount")
              .getAttribute("itemResults");
          fetch(
            `/search/suggest.json?q=${i}&options%5Bprefix%5D=last&resources[type]=collection`
          )
            .then((e) => {
              if (!e.ok) throw new Error(`${e.status}: ${e}`);
              return e.json();
            })
            .then((i) => {
              var a = i.resources.results.collections;
              if (a.length > 0) {
                $(o).show();
                var n = "";
                n += `<h2 class="search-category">${Shopify.translations.recipe}</h2>`;
                var l = 0;
                a.forEach((e, t) => {
                  var i =
                    Shopify.collections[
                      "collection_type_" + e.id
                    ]?.toLowerCase();
                  if ("recipe" == i) {
                    if (l > 1) return !0;
                    (n +=
                      '<div id="cusvisible-' +
                      e.id +
                      '" class="s-item-coll indiv-search-listing-grid">'),
                      (n += '<div class="grid tst-search-grid">'),
                      (n +=
                        '<div class="grid__item large--one-fifth live-search--image">'),
                      (n +=
                        '<a href="' +
                        e.url +
                        '" title="' +
                        e.title +
                        '"><span>'),
                      (n +=
                        '<img src="' +
                        e.featured_image.url +
                        '" alt="' +
                        e.title +
                        '" class="search-drawer-img ls-is-cached lazyloaded">'),
                      (n += "</span></a>"),
                      (n += "</div>"),
                      (n +=
                        '<div class="grid__item line-search-content large--four-fifths">'),
                      (n += '<h5 class="result-title">'),
                      (n += '<a href="' + e.url + '">' + e.title + "</a>"),
                      (n += "</h5>"),
                      (n += "</div>"),
                      (n += "</div>"),
                      (n +=
                        '<span class="search-drawer-separator"><hr></span>'),
                      (n += "</div>"),
                      l++;
                  }
                }),
                  $(o).html(n),
                  setTimeout(function () {
                    s.removeClass("vjs-seeking"), s.html(t.innerHTML);
                  }, 1);
              } else
                s.removeClass("vjs-seeking"),
                  r > 0
                    ? s.html(e)
                    : s.html(
                        '<div class="tst-search-no-result">0 RESULTS FOUND</div>'
                      );
            });
        })
        .catch((e) => {
          throw e;
        });
  } else s.html("");
}
$(document).ready(function () {
  setInterval(() => {
    const e = $("#y-badges .y-badge-reviews").html(),
      t = $("#y-badges .y-badge-stars .sr-only").html();
    if (e && t) {
      const i = parseFloat(t.match(/\d+(\.\d+)?/)[0]);
      $("#annstarRating").html(`${i} stars out of 5 from ${e} reviews`);
    }
  }, 100),
    $(document).on("click", ".edit-button", function () {
      let e = $(this).attr("aria-controls");
      $(`#${e}`).slideToggle();
    }),
    $(document).on("click", ".add-address-btn", function () {
      let e = $(this).attr("aria-controls");
      $(`#${e}`).slideToggle();
    }),
    $(document).on("click", ".del-button", function () {
      const e = $(this),
        t = e.attr("data-target");
      confirm(e.attr(attributes.confirmMessage)) &&
        $.post(t, { _method: "delete" }).done(function () {
          location.reload();
        });
    }),
    $(document).on("click", ".cancel-btn, .cancel_adrrr", function () {
      $(this).closest(".EditAddress-section").slideToggle();
    }),
    $(document).on("click", ".cancel-btn", function () {
      $(this).closest("#AddAddress").slideToggle();
    }),
   $(document).on("click", "#cart-icon-bubble", function (e) {
      e.preventDefault();
     console.log('clicked');
     if ($("body").hasClass("cart")) {
       window.location.href="/cart";
       $("cart-drawer").removeClass("animate active");
     }
      // if (!$("body").hasClass("cart")) {
      //   $("cart-drawer").toggleClass("animate active");
      //   $("body").toggleClass("overflow-hidden");
      // }
    }),
    mainProductSlider();
  let e = 0;
  $(".pages-flex").each(function () {
    let t = $(this).outerHeight();
    t > e && (e = t);
  }),
    $(".pages-flex").height(e + 30),
    $(document).on("click", ".acc_tab_link", function (e) {
      e.preventDefault();
      var t = $(this),
        i = t.attr("href");
      $(".acc_tab_link").removeClass("active"),
        t.addClass("active"),
        $(".acc_tab_content").hide(),
        $(i).show(),
        (window.location.hash = i);
      $("html, body").animate({ scrollTop: 0 }, "fast");
    }),
    jQuery(".story-banner-section")
      .parents()
      .find("body")
      .addClass("header-img-overlap"),
    $(document).on("click", ".header_search", function () {
      $(this).parents("body").find(".header__search details").attr("open", !0);
    }),
    $(document).on("click", ".accordion details", function () {
      $("details").not(this).removeAttr("open");
    }),
    setTimeout(function () {
      var e = 0;
      $(".card__content .card__information").each(function () {
        var t = $(this).height();
        t > e && (e = t);
      }),
        $(".related-products .card__content .card__information").height(e);
    }, 2e3),
    setInterval(function () {
      if ($(".menu-drawer-container.menu-opening[open]").length) {
        var e = $(".header-wrapper"),
          t = $(".menu-drawer__utility-links"),
          i = $(".menu-drawer-container.menu-opening[open] #menu-drawer"),
          s = e.outerHeight(),
          o =
            (t.outerHeight(),
            (window.visualViewport
              ? window.visualViewport.height
              : window.innerHeight) - s);
        i.css("height", o + "px");
      }

      if ($(".drawer-items").length > 0) {
        var r = $(".drawer-items").attr("data-count");
        $("#header-cart-icon-bubble .cart-count-bubble").removeClass(
          "is-empty"
        ),
          $(
            '#header-cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]'
          ).html(r);
      } else $("#header-cart-icon-bubble .cart-count-bubble").addClass("is-empty"), $('#header-cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').html("");
    }, 100),
    $(".filer__label").click(function () {
      var e = $(this).next(".mobile-facets__list-wrap");
      e.is(":visible")
        ? ($(this).removeClass("active"), e.stop(!0, !0).slideUp())
        : ($(".mobile-facets__list-wrap").slideUp(),
          $(".filer__label").removeClass("active"),
          $(this).addClass("active"),
          e.stop(!0, !0).slideDown());
    }),
    setTimeout(function () {
      var e = $(".collection-our-teas #product-grid .grid__item")
        .eq(1)
        .height();
      $(".collection__first--slide").height(e),
        $(".collection__first--slide .slick-slide").height(e),
        $(".collection__last--slide").height(e),
        $(".collection__first--slide").show();
      var t = $(".all_grid--item").height();
      $(".grid-first_slide").height(t);
      var i = $(".card__media").height();
      $(".related-products .slick-arrow").css("top", i / 2 + "px");
    }, 2500),
    $(document).on("click", ".mobile-facets__wrapper", function () {
      console.log("facetsclicked>>>>>");
      $(".mobile-facets__details").addClass("menu-opening").attr("open", !0);
    }),
    $(document).on("click", ".down-arrow-link", function () {
      $("html, body").animate(
        { scrollTop: $(".home-rich-text").offset().top - 100 },
        1e3
      );
    }),
    setInterval(function () {
      collectionFirstSlide(), mainProductSlider();
    }, 100),
    $(document).on("click", ".facet-filters__label", function () {
      $(".radio-group").toggle();
    }),
    $(document).on("click", ".apply_filterrr", function () {
      $(this)
        .parents(".facets-container")
        .find(".mobile-facets__open-wrapper")
        .trigger("click");
    }),
    $(document).on("click", ".active-facets__button-wrapper", function () {
      $(this)
        .parents(".facets-container")
        .find(".mobile-facets__open-wrapper")
        .trigger("click");
    }),
    $(document).on("click", ".sign__btn", function (e) {
      e.preventDefault();
    }),
    $(document).on("click", ".location_redirect__link", function () {
      var e = $(this).data("target");
      $("#" + e)
        .show()
        .addClass("modal_opened"),
        $("body").addClass("location_modal_opened");
    }),
    $(document).on("click", ".lr_close,.default_location", function (e) {
      e.preventDefault();
      var t = $(this).data("target");
      $("#" + t)
        .hide()
        .removeClass("modal_opened"),
        $("body").removeClass("location_modal_opened");
    }),
    $(window).on("click", function (e) {
      "location_redirect__modal" === e.target.id &&
        ($("#location_redirect__modal").hide().removeClass("modal_opened"),
        $("body").removeClass("location_modal_opened"));
    }),
    $(".block_iwt_main").slick({
      dots: !1,
      autoplay: !0,
      infinite: !0,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      centerMode: !0,
      centerPadding: "100px",
      responsive: [
        {
          breakpoint: 1224,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: !1,
            centerPadding: "80px",
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: !1,
            centerPadding: "50px",
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerPadding: "50px",
            slidesToScroll: 1,
          },
        },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    }),
    $(".text-block-content").slick({
      dots: !1,
      arrows: !0,
      autoplay: !0,
      infinite: !0,
      centerMode: !0,
      centerPadding: "10px",
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 600, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      ],
    }),
    $(".testimonials-block").slick({
      dots: !0,
      autoplay: !0,
      autoplaySpeed: 1e4,
      arrows: !0,
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: !0,
      centerPadding: "0px",
      responsive: [
        { breakpoint: 1345, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        {
          breakpoint: 768,
          settings: { arrows: !0, slidesToShow: 1, slidesToScroll: 1 },
        },
      ],
    }),
    $(".video_slider").slick({
      dots: !0,
      autoplay: !0,
      arrows: !0,
      infinite: !0,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: !0,
      centerPadding: "0px",
      adaptiveHeight: !1,
    }),
    $(".video__images-section").slick({
      dots: !1,
      autoplay: !0,
      autoplaySpeed: 8e3,
      arrows: !0,
      infinite: !0,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: !0,
      centerPadding: "0px",
      adaptiveHeight: !1,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        {
          breakpoint: 768,
          settings: { dots: !0, slidesToShow: 1, slidesToScroll: 1 },
        },
      ],
    }),
    $(".collection__slide-slider").slick({
      dots: !1,
      autoplay: !0,
      autoplaySpeed: 8e3,
      arrows: !1,
      infinite: !0,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: !0,
      centerPadding: "0px",
      adaptiveHeight: !1,
    }),
    $(".recommended__product-slider").slick({
      dots: !1,
      autoplay: !0,
      autoplaySpeed: 8e3,
      arrows: !0,
      infinite: !0,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: !0,
      centerPadding: "0px",
      adaptiveHeight: !1,
    }),
    $(".video__images-section").on("afterChange", function (e, t, i, s) {
      var o = t.$slides[i],
        r = $(o).data("target");
      $(this)
        .parents(".video-with-text")
        .find(".video_contentt")
        .removeClass("active"),
        $(this)
          .parents(".video-with-text")
          .find(`.video_contentt[id="${r}"]`)
          .addClass("active");
    }),
    $(".js-collection-slider").each(function () {
      var e = $(this),
        t = e.data("mob"),
        i = e.data("desk");
      $(window).width() <= 767 && (i = t),
        e.slick({
          focusOnSelect: !0,
          lazyLoad: "ondemand",
          dots: !1,
          infinite: !0,
          centerMode: !0,
          arrows: !0,
          centerPadding: "140px",
          speed: 300,
          slidesToShow: i,
          slidesToScroll: 1,
          responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: t } },
            { breakpoint: 480, settings: { slidesToShow: t } },
          ],
        });
    }),
    $(document).on("click", ".trigger__tag", function (e) {
      e.preventDefault();
      var t = $(this).attr("href");
      $(`.mobile-facets__checkbox[value="${t}"]`).click();
    }),
    $(".read-more-button").click(function () {
      $(".product-description .short").hide(),
        $(".product-description .long").show();
    }),
    $(".read-less-button").click(function () {
      $(".product-description .long").hide(),
        $(".product-description .short").show();
    }),
    $(window).width() < 767 &&
      ($(document).on("click", ".footer-block__heading", function () {
        var e = $(this).next(".footer-block__details-content"),
          t = $(this);
        $(".footer-block__details-content").not(e).slideUp(),
          e.stop(!0, !0).slideToggle(),
          $(".footer-block__heading").not(t).removeClass("active"),
          t.toggleClass("active");
      }),
      $(".recommended__mobProduct-slider").slick({
        dots: !1,
        autoplay: !0,
        autoplaySpeed: 8e3,
        arrows: !0,
        infinite: !0,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: !0,
        centerPadding: "0px",
        adaptiveHeight: !1,
      })),
    $(".tab-title").click(function () {
      $(".tab-title").removeClass("active"), $(this).addClass("active");
      var e = $(this).attr("data-index");
      $(".featured-slider").hide().removeClass("active"),
        $(".featured-slider.tabcontent-" + e)
          .show()
          .addClass("active"),
        $(".slideshow__control-wrapper").each(function () {
          let e = $(this),
            t = e.find(
              ".slider-counter__link--dots.slider-counter__link--active"
            ),
            i = t.offset()?.left || null,
            s = e.offset()?.left || null;
          if (null !== i && null !== s) {
            let o = s - i + e.width() / 2 - t.width() / 2;
            e.css("transform", `translateX(${o}px)`);
          }
        });
    }),
    $(".video_slide").slick({
      dots: !0,
      arrows: !0,
      infinite: !1,
      slidesToShow: 1,
      slidesToScroll: 1,
    }),
    $(".header__menu-item").hover(
      function () {
        $(this).parents("details").attr("open", "true"),
          $(this).parents("details").addClass("submenu-opened"),
          $(this).attr("aria-expanded", "true");
      },
      function () {
        $(this).parents(".mega-menu").removeAttr("open"),
          $(this).parents("details").removeClass("submenu-opened"),
          $(this).attr("aria-expanded", "true");
      }
    ),
    $(".header__menu-item").click(function () {
      var e = $(this).parents("details");
      e.attr("open")
        ? (e.removeAttr("open"),
          e.removeClass("submenu-opened"),
          $(this).attr("aria-expanded", "false"))
        : (e.attr("open", "true"),
          e.addClass("submenu-opened"),
          $(this).attr("aria-expanded", "true"));
    }),
    $(".header__menu-item, .mega-menu__content").hover(
      function () {
        $(this).parents(".header-wrapper").addClass("menu-opened");
      },
      function () {
        $(this).parents(".header-wrapper").removeClass("menu-opened");
      }
    ),
    $(".card_desktop").click(function () {
      var e = $(this).find(".desk_accordion").attr("data-target");
      $(this).addClass("active"),
        $(this).siblings(".card_desktop").removeClass("active"),
        $(".panel-accordion .collapse").removeClass("show"),
        $(e).addClass("show");
    }),
    $(".mob_accordion").click(function () {
      $(this).toggleClass("active");
      var e = $(this).attr("data-target");
      $(e).toggleClass("show"),
        $(this)
          .closest(".card_mobile")
          .siblings(".card_mobile")
          .find(".collapse")
          .removeClass("show"),
        $(this)
          .closest(".card_mobile")
          .siblings(".card_mobile")
          .find(".mob_accordion")
          .removeClass("active");
    }),
    $(document).on(
      "click",
      ".search__item__wrapper .js-load-more",
      function () {
        var e = $(this),
          t = e.closest(".search__item__wrapper"),
          i = e.closest(".load-More-Wrapper"),
          s = parseInt(i.attr("item_count")),
          o = t.find(".search__item:hidden");
        e.attr("disabled", !0),
          e.find("[load-more-text]").addClass("hide"),
          e.find("[loader]").removeClass("hide"),
          setTimeout(function () {
            o.slice(0, s).show(),
              e.attr("disabled", !1),
              e.find("[load-more-text]").removeClass("hide"),
              e.find("[loader]").addClass("hide"),
              t.find(".search__item:hidden").length <= 0 && i.hide();
          }, 700);
      }
    );
  new MutationObserver(() => {
    $(".menu-drawer-container").attr("open")
      ? $(".header").addClass("drawer_opened")
      : $(".header").removeClass("drawer_opened");
  }).observe($(".menu-drawer-container")[0], {
    attributes: !0,
    attributeFilter: ["open"],
  });
});
var lastScrollTop = 0;
function initSlick() {
  $(window).width() < 767
    ? $(".product_imageText--items").hasClass("slick-initialized") ||
      $(".product_imageText--items").slick({
        dots: !0,
        arrows: !1,
        infinite: !0,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: !0,
        centerPadding: "0px",
      })
    : $(".product_imageText--items").hasClass("slick-initialized") &&
      $(".product_imageText--items").slick("unslick");
}
function collectionFirstSlide() {
  $(".collection__slide-slider").hasClass("slick-initialized") ||
    $(".collection__slide-slider").slick({
      dots: !1,
      autoplay: !0,
      autoplaySpeed: 8e3,
      arrows: !1,
      infinite: !0,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: !0,
      centerPadding: "0px",
      adaptiveHeight: !1,
    });
}
setTimeout(function () {
  $(".main-slide-image").removeClass("hide_media-load");
}, 1500);

function mainProductSlider() {
  // Initialize the main slider if it's not already initialized
  if (
    !$(".main-slide-image").hasClass("slick-initialized") &&
    !$(".main-slide-image").hasClass("hide_media-load")
  ) {
    $(".main-slide-image").slick({
      dots: true,
      autoplay: true,
      autoplaySpeed: 8000,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0px",
      adaptiveHeight: false,
    });
  }

  // Initialize the quick add modal slider if it's not already initialized
  if (!$(".quick-add-modal .main-slide-image").hasClass("slick-initialized")) {
    $(".quick-add-modal .main-slide-image").slick({
      dots: true,
      autoplay: true,
      autoplaySpeed: 8000,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0px",
      adaptiveHeight: false,
    });
  }
}

// Call the function for the login password

// Call the function for the register password
// togglePasswordVisibility('RegisterForm-password', 'registerPassword');

$(window).scroll(function (e) {
  if (0 == $(window).scrollTop())
    $("body").removeClass("scrolled_up scrolled_down").addClass("scrolled_top");
  else if ($(window).scrollTop() > 30) {
    var t = $(this).scrollTop();
    0 == $(".header:hover").length &&
      (t > lastScrollTop
        ? $("body")
            .addClass("scrolled_down")
            .removeClass("scrolled_up scrolled_top")
        : $("body")
            .addClass("scrolled_up")
            .removeClass("scrolled_down scrolled_top"),
      (lastScrollTop = t));
  }
}),
  initSlick(),
  $(window).resize(function () {
    initSlick(), collectionFirstSlide(), mainProductSlider();
  });
try {
  const e = document.querySelector(".mobile-facets__inner"),
    t = document.querySelector(".mobile-facets__wrapper");
  document.addEventListener("click", function (i) {
    try {
    if (!e.contains(i.target) && !t.contains(i.target)) {
      const e = t.querySelector(".mobile-facets__disclosure");
      e && (e.classList.remove("menu-opening"), e.removeAttribute("open"));
    }
    }catch(ee){}
  });
  const i = document.querySelector(".facet-filters__label"),
    s = document.querySelector(".sorting");
  document.addEventListener("click", function (e) {
    if (!i.contains(e.target)) {
      const e = s.querySelector(".radio-group");
      e && (e.style.display = "none");
    }
  });
} catch (e) {}
function validatePassword(e) {
  return e.length < 12
    ? "Password must be at least 12 characters long and include a combination of uppercase letters, lowercase letters, numbers, and special characters."
    : /[A-Z]/.test(e) && /[a-z]/.test(e) && /[!@#$%^&*(),.?":{}|<>]/.test(e)
    ? ""
    : "Password must be at least 12 characters long and include a combination of uppercase letters, lowercase letters, numbers, and special characters.";
}
function yotpoReload() {
  yotpoWidgetsContainer.initWidgets();
}
function scrollToTarget() {
  let e = $("#yotpo-reviews-main-widget");
  e.length &&
    (console.log("Scrolling to:", e),
    $("html, body").animate({ scrollTop: e.offset().top - 50 }));
}
if (
  ($(document).ready(function () {
    0 === $('li.thumbnail-list__item button[aria-current="true"]').length &&
      $("li.thumbnail-list__item button").first().attr("aria-current", "true");
  }),
  (window.onVariantChange = (e) => {
    $(".pick__selection").hide(),
      $(".product-form__submit").show(),
      $(".variant_price").html(
        "- " + Shopify.formatMoney(e.price, "£{{amount}}")
      ),
      $(".variant_price").attr("data-price", `${e.price}`);
  }),
  $(document).on("click", ".quantity__button", function () {
    var e = $(".pdp_quantity__input").val(),
      t = parseInt($(".variant_price").attr("data-price")) * e;
    $(".variant_price").html("- " + Shopify.formatMoney(t, "£{{amount}}"));
  }),
   $(document).on('input', '.quantity__input', function () {
    const value = $(this).val(),
     t = parseInt($(".variant_price").attr("data-price")) * value;
    $(".variant_price").html("- " + Shopify.formatMoney(t, "£{{amount}}"));
  }),  
  $(document).ready(function () {
    $(".register_btn, .login__btn").click(function (e) {
      var t = !0,
        i = "";
      if (
        ($(".error-message").remove(),
        $("#check_box_input").prop("checked") ||
          ((t = !1),
          $("#check_box_input").addClass("error"),
          $(".contact__checkbox-wrap").after(
            '<div class="error-message" style="color: red;">You must agree to the terms and conditions to continue</div>'
          )),
        $(this).hasClass("login__btn"))
      ) {
        var s = $("#CustomerEmail").val().trim(),
          o = $("#CustomerPassword").val().trim();
        if ("" === s || "" === o)
          (t = !1),
            (i =
              '<div class="error-message" style="color: red;">To continue, please ensure both your email and password are entered correctly.</div>'),
            $('#customer_login [value="customer_login"]').after(i);
        else {
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(s) ||
            ((t = !1),
            (i =
              '<div class="error-message" style="color: red;">Invalid email address. Please enter a valid email address</div>'),
            $('#customer_login value="customer_login"').after(i));
        }
      }
      if ($(this).hasClass("register_btn")) {
        var r = $("#RegisterForm-FirstName").val().trim(),
          a = $("#RegisterForm-LastName").val().trim(),
          n = validatePassword(
            (o = $("#create_customer input[name='customer[password]']")
              .val()
              .trim())
          );
        ("" !== r && "" !== a) ||
          ((t = !1),
          (i =
            '<div class="error-message" style="color: red;">Please enter your first name and last name.</div>'),
          $('#create_customer [name="form_type"]').after(i));
      }
      if (
        (n &&
          ((t = !1),
          $(".error-messagess").remove(),
          $("#create_customer input[name='customer[password]']")
            .addClass("error")
            .parent()
            .after(
              `<div class="error-messagess" style="color: red;">${n}</div>`
            )),
        !t)
      )
        return e.preventDefault(), !1;
      $(".create_customer").length > 0 && $(".create_customer").submit(),
        $("#customer_login").length > 0 && $("#customer_login").submit();
    }),
      $("#create_customer input[name='customer[password]']").on(
        "input",
        function () {
          var e = validatePassword($(this).val().trim());
          $(".error-messagess").remove(),
            e &&
              $(this)
                .parent()
                .after(
                  `<div class="error-messagess" style="color: red;">${e}</div>`
                );
        }
      ),
      $(document).on("click", ".button_reset", function (e) {
        var t = !0,
          i = validatePassword($(".reset-password #password").val().trim());
        if (
          (i &&
            ((t = !1),
            $(".error-messagess").remove(),
            $(".reset-password #password")
              .addClass("error")
              .parent()
              .after(
                `<div class="error-messagess" style="color: red;">${i}</div>`
              )),
          !t)
        )
          return e.preventDefault(), !1;
        $(".button_reset").submit();
      }),
      $(".reset-password #password").on("input", function () {
        var e = validatePassword($(this).val().trim());
        $(".error-messagess").remove(),
          e &&
            $(this)
              .parent()
              .after(
                `<div class="error-messagess" style="color: red;">${e}</div>`
              );
      }),
      $(".btn__reset").click(function (e) {
        e.preventDefault();
        var t = $("#RecoverEmail").val().trim();
        if (($(".error-message").remove(), "" !== t)) {
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(t)
            ? ($(".btn__reset").hide(),
              $(".btn_Cancle").hide(),
              $(".reset_pass p").after(
                '<div class="error-message" style="color: red;">A password reset link has been sent to your email (if it is associated with an account). Please check your inbox and follow the instructions to reset your password.</div>'
              ),
              setTimeout(function () {
                $(e.target).closest("form").submit();
              }, 5e3))
            : $(".reset_pass p").after(
                '<div class="error-message" style="color: red;">Please enter a valid email address.</div>'
              );
        } else $(".reset_pass p").after('<div class="error-message" style="color: red;">Please enter your email address.</div>');
      });
    var e = ["United Kingdom"];
    $("<option>").val("other").text("other");
    $('[name="address[country]"] option').each(function () {
      var t = $(this).text();
      e.includes(t) ? $(this).show() : $(this).hide();
    });
  }),
  window.location.hash)
) {
  setTimeout(scrollToTarget, 1e3);
  let e = new MutationObserver(() => {
    $("#yotpo-reviews-main-widget").length &&
      (scrollToTarget(), e.disconnect());
  });
  e.observe(document.body, { childList: !0, subtree: !0 });
}

window.refreshCart = () => {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      console.log("html ", html);
      const count = parseInt(
        html.querySelector("cart-drawer-items").getAttribute("item_count")
      );
      console.log("count ", count);
      const selectors = [
        "cart-drawer-items",
        ".cart-drawer__footer",
        ".drawer__heading-wrap",
        ".cdm-progess-content",
        ".drawer-items",
        ".join__wrapper",
        ".drawer__footer",
        ".drawer__inner-empty"
      ];
      $("button.cart__checkout-button").attr("disabled", false);
      if (count > 0) {
        $("cart-drawer").removeClass("is-empty");
        document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
          bubble.classList.remove("hidden");
        });
      } else {
        $("cart-drawer").addClass("is-empty");
        document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
          bubble.classList.add("hidden");
        });
      }
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
      document
        .querySelectorAll(".cart-count-bubble span:first-child")
        .forEach((bubble) => {
          bubble.innerHTML = count;
        });
      setTimeout(function() {
             yotpoReload();
      },1000);
      console.log("cart drawer reffresh");
    })
    .catch((e) => {
      console.error(e);
    });

};

(function () {
  var e,
    t = function (e, t) {
      return function () {
        return e.apply(t, arguments);
      };
    };
  (e = (function () {
    function e() {}
    return (
      (e.prototype.extend = function (e, t) {
        var i, s;
        for (i in e) null != (s = e[i]) && (t[i] = s);
        return t;
      }),
      (e.prototype.isMobile = function (e) {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          e
        );
      }),
      e
    );
  })()),
    (this.WOW = (function () {
      function i(e) {
        null == e && (e = {}),
          (this.scrollCallback = t(this.scrollCallback, this)),
          (this.scrollHandler = t(this.scrollHandler, this)),
          (this.start = t(this.start, this)),
          (this.scrolled = !0),
          (this.config = this.util().extend(e, this.defaults));
      }
      return (
        (i.prototype.defaults = {
          boxClass: "wow",
          animateClass: "animated",
          offset: 0,
          mobile: !0,
        }),
        (i.prototype.init = function () {
          var e;
          return (
            (this.element = window.document.documentElement),
            "interactive" === (e = document.readyState) || "complete" === e
              ? this.start()
              : document.addEventListener("DOMContentLoaded", this.start)
          );
        }),
        (i.prototype.start = function () {
          var e, t, i, s;
          if (
            ((this.boxes = this.element.getElementsByClassName(
              this.config.boxClass
            )),
            this.boxes.length)
          ) {
            if (this.disabled()) return this.resetStyle();
            for (t = 0, i = (s = this.boxes).length; t < i; t++)
              (e = s[t]), this.applyStyle(e, !0);
            return (
              window.addEventListener("scroll", this.scrollHandler, !1),
              window.addEventListener("resize", this.scrollHandler, !1),
              (this.interval = setInterval(this.scrollCallback, 50))
            );
          }
        }),
        (i.prototype.stop = function () {
          if (
            (window.removeEventListener("scroll", this.scrollHandler, !1),
            window.removeEventListener("resize", this.scrollHandler, !1),
            null != this.interval)
          )
            return clearInterval(this.interval);
        }),
        (i.prototype.show = function (e) {
          return (
            this.applyStyle(e),
            (e.className = e.className + " " + this.config.animateClass)
          );
        }),
        (i.prototype.applyStyle = function (e, t) {
          var i, s, o;
          return (
            (s = e.getAttribute("data-wow-duration")),
            (i = e.getAttribute("data-wow-delay")),
            (o = e.getAttribute("data-wow-iteration")),
            e.setAttribute("style", this.customStyle(t, s, i, o))
          );
        }),
        (i.prototype.resetStyle = function () {
          var e, t, i, s, o;
          for (o = [], t = 0, i = (s = this.boxes).length; t < i; t++)
            (e = s[t]), o.push(e.setAttribute("style", "visibility: visible;"));
          return o;
        }),
        (i.prototype.customStyle = function (e, t, i, s) {
          var o;
          return (
            (o = e
              ? "visibility: hidden; -webkit-animation-name: none; -moz-animation-name: none; animation-name: none;"
              : "visibility: visible;"),
            t &&
              (o +=
                "-webkit-animation-duration: " +
                t +
                "; -moz-animation-duration: " +
                t +
                "; animation-duration: " +
                t +
                ";"),
            i &&
              (o +=
                "-webkit-animation-delay: " +
                i +
                "; -moz-animation-delay: " +
                i +
                "; animation-delay: " +
                i +
                ";"),
            s &&
              (o +=
                "-webkit-animation-iteration-count: " +
                s +
                "; -moz-animation-iteration-count: " +
                s +
                "; animation-iteration-count: " +
                s +
                ";"),
            o
          );
        }),
        (i.prototype.scrollHandler = function () {
          return (this.scrolled = !0);
        }),
        (i.prototype.scrollCallback = function () {
          var e;
          if (
            this.scrolled &&
            ((this.scrolled = !1),
            (this.boxes = function () {
              var t, i, s, o;
              for (o = [], t = 0, i = (s = this.boxes).length; t < i; t++)
                (e = s[t]) && (this.isVisible(e) ? this.show(e) : o.push(e));
              return o;
            }.call(this)),
            !this.boxes.length)
          )
            return this.stop();
        }),
        (i.prototype.offsetTop = function (e) {
          var t;
          for (t = e.offsetTop; (e = e.offsetParent); ) t += e.offsetTop;
          return t;
        }),
        (i.prototype.isVisible = function (e) {
          var t, i, s, o, r;
          return (
            (i = e.getAttribute("data-wow-offset") || this.config.offset),
            (o = (r = window.pageYOffset) + this.element.clientHeight - i),
            (t = (s = this.offsetTop(e)) + e.clientHeight),
            s <= o && t >= r
          );
        }),
        (i.prototype.util = function () {
          return this._util || (this._util = new e());
        }),
        (i.prototype.disabled = function () {
          return (
            !this.config.mobile && this.util().isMobile(navigator.userAgent)
          );
        }),
        i
      );
    })());
}).call(this),
  (wow = new WOW({ animateClass: "animated", offset: 100 })),
  wow.init(),
  $(".js-clear-search").click(function () {
    $(".js-search-input").val("");
  });


$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("index")) $(window).scrollTop(0);
  }, 0);
});